<template>
  <div>
    <section class="container mx-auto grid grid-cols-1 gap-10 w-full pb-16" :class="isImage ? 'md:grid-cols-1' : null">
    <div class="flex items-center px-10 md:px-0 pt-16 md:pt-0">
      <div class="w-full">
        <h2 class="text-3xl font-bold mb-7 title relative">{{descripcion.titulo}}</h2>
        <img class="object-cover w-full rounded h-full " :src="descripcion.imagen" alt="auditorio">
        <p class="text-sm"><strong> Tomada de:</strong> Cruz-Roa A, Gilmore H, Basavanhally A, Feldman M, Ganesan S, Shih N, et al. (2018) High-throughput adaptive sampling for whole-slide histopathology image analysis (HASHI) via convolutional neural networks: Application to invasive breast cancer detection. PLoS ONE 13(5): e0196828. https://doi.org/10.1371/journal.pone.0196828</p>
        <br>
        <!--<h2 class="text-3xl font-bold mb-7 title relative">{{descripcion.titulo}}</h2>-->
        <p class="leading-9 text-xl" align="justify" v-if="patrocinar">{{descripcion.cuerpo}}</p>
        <p class="leading-9 text-xl" align="justify" v-else>{{eventoSeleccionado.descripcion}}</p>
        <a class="mt-3 text-theme-color inline-flex items-center py-2 font-extrabold text-lg " :href="descripcion.link" target="_blank" v-if="descripcion.link.includes('http')">Conocer más
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
        <a class="mt-3 text-theme-color inline-flex items-center py-2 font-extrabold text-lg" :href="descripcion.link" v-if="hasLink && !descripcion.link.includes('http')">Conocer más
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
    </div>
  </section>
  </div>
  
</template>

<script>
  import {mapGetters, mapState} from "vuex";

  export default {
    props: {
      descripcion: {
        require: true
      },
      isImage: {
        type: Boolean,
        default: false
      },
      hasLink: {
        type: Boolean,
        default: false
      },
      patrocinar: {
        type:Boolean,
        default: false
      }
    },
    computed: {
      ...mapState(["idEventoActual"]),
      ...mapGetters(["eventoSeleccionado"])
    },
  }
</script>

<style scoped>
  .title::before{
    content: '';
    position: absolute;
    width: 3rem;
    top: -15px;
    border-radius: 20px;
    border: 2px solid var(--theme-color);
  }
</style>
